/**
 * Delay execution for the provided number of milliseconds.
 * Useful for retry logic and UX pacing.
 */
export const sleep = (ms: number): Promise<void> =>
  new Promise(resolve => globalThis.setTimeout(resolve, ms));
